import * as Linking from 'expo-linking';
import * as Notifications from 'expo-notifications';

// npx uri-scheme open "com.primaryrecord.primaryrecord.android://--/app/profiles/profile-activity-details?auditLogId=9ab50b53-4d94-4e8f-9109-2ab9bed4033d&profileId=f1b18ada-2dd4-46b4-9228-9ec390435921" --android
// npx uri-scheme open "com.primaryrecord.primaryrecord.android://--/app/activity/root" --android
// npx uri-scheme open "primary-record-app:///app/activity/root" --ios
// npx uri-scheme open "primary-record-app:///app/activity/root?regcode=E2EFamily" --ios
// npx uri-scheme open "primary-record-app:///app/profiles/profile-activity-details?auditLogId=9ab50b53-4d94-4e8f-9109-2ab9bed4033d&profileId=f1b18ada-2dd4-46b4-9228-9ec390435921" --android

import { LinkingOptions } from '@react-navigation/native';
import { Platform } from 'react-native';

const prefix = Linking.createURL('/');

const getNotificationData = (notification: Notifications.NotificationResponse): { url: string } | null => {
    const data = notification.notification.request.content.data;
    if (data && typeof data.url === 'string') {
        return { url: data.url };
    }
    return null;
};

// npx uri-scheme open "primary-record-app://redirect" --ios
export const linkingOptions: LinkingOptions<{}> = {
    prefixes: [prefix, 'https://www.primaryrecord.app', 'https://dev.primaryrecord.app'],
    getInitialURL:
        Platform.OS === 'web'
            ? undefined
            : async () => {
                  const initialUrl = await Linking.getInitialURL();

                  if (initialUrl !== null) {
                      return initialUrl;
                  }

                  // Check if we received a notification while the app was not running
                  const response = await Notifications.getLastNotificationResponseAsync();
                  return response ? getNotificationData(response)?.url : null;
              },
    subscribe:
        Platform.OS === 'web'
            ? undefined
            : (listener) => {
                  // Listen to incoming deep links (e.g. OAuth redirects back to the app)
                  const urlSubscription = Linking.addEventListener('url', ({ url }) => {
                      listener(url);
                  });

                  // Listen to incoming notifications
                  const notificationSubscription = Notifications.addNotificationResponseReceivedListener((response) => {
                      const url = getNotificationData(response)?.url;
                      if (url) {
                          listener(url);
                      }
                  });

                  return () => {
                      urlSubscription.remove();
                      notificationSubscription.remove();
                  };
              },
};
